/**
 * Телефоны хранятся без «+» (в базе только цифры), а в контактах номер должен показываться
 * в международном виде. Поэтому «+» добавляем при выводе, а не при сохранении.
 */
export const formatPhoneWithPlus = (phone?: string | number | null): string => {
  if (!phone && phone !== 0) return '';

  const value = String(phone).trim();
  if (!value) return '';

  return value.startsWith('+') ? value : `+${value}`;
};

/** Значение для ссылки tel: — без пробелов, скобок и дефисов, иначе часть телефонов не набирается */
export const getPhoneHref = (phone?: string | number | null): string => {
  const digits = String(phone ?? '').replace(/\D/g, '');

  return digits ? `tel:+${digits}` : '';
};
